import React, { Component } from 'react';
import { Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faPhone, faPlus, faPrint } from "@fortawesome/free-solid-svg-icons";
import TableOperatorOptions from "../Blocks/TableOperatorOptions";
import { toast } from "react-toastify";
import UserStore from "../../stores/UserStore";
import { sortList } from "../ALHUtility";
import MitgliedItem from '../../models/Mitglied';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import MitgliedService from '../../services/MitgliedService';
import { WaveTopBottomLoading } from '../WaveTopBottomLoading';
import moment from 'moment';
import { DataGridPro, GridColDef, GridRenderCellParams, GridApi, GridApiPro } from '@mui/x-data-grid-pro';
import { deDE } from '@mui/x-data-grid-pro/locales';

interface MitgliederlisteParams {
    search?: string
}

interface MitgliederlisteProps extends RouteComponentProps<MitgliederlisteParams> {
    mode?: string
    addNew?: boolean
    withAdd?: boolean
    withInfo?: boolean
}

interface MitgliederlisteState {
    loading: boolean,
    mitglieder: MitgliedItem[],
    search: string,
    onlyActive: boolean,
    addingNew: number,
    addedNewNr: string,
    numShow: number,
    updateTitle: boolean,

    sort: string,
    sort_mode: string

    mtglNew: number
    mtglBonus: number
}

class Mitgliederliste extends Component<MitgliederlisteProps, MitgliederlisteState> {

    private gridApiRef = React.createRef<GridApiPro>() as React.MutableRefObject<GridApiPro>;
    private readonly gridSettingsStorageKey = 'mitgliederliste-grid-settings';
    private gridColumns: GridColDef[] | null = null;
    private gridColumnsMode: string | undefined = undefined;

    constructor(props: MitgliederlisteProps) {
        super(props);

        if (!UserStore.hasBerechtigung('bst_mg') && typeof this.props.history !== "undefined") {
            this.props.history.push("/notallowed/");
        }

        let search: string = '';
        if (typeof this.props.match !== "undefined") {
            search = this.props.match.params.search ?? '';
        }

        this.state = {
            loading: true,
            mitglieder: [],
            search: search,
            onlyActive: true,
            addingNew: 0,
            addedNewNr: '',
            numShow: -1,
            updateTitle: true,

            sort: 'mgNr',
            sort_mode: 'asc',

            mtglNew: 0,
            mtglBonus: 0,
        }

    }

    async componentDidUpdate(prevProps: MitgliederlisteProps) {
        if (this.props.match && prevProps.match && this.props.match.params.search !== prevProps.match.params.search) {
            this.changeSearch(this.props.match.params.search ?? '');
        }
    }

    async componentDidMount() {

        //check for new Blanko Mitglied to create
        if (typeof this.props.addNew !== "undefined" && this.props.addNew) {
            this.setState({
                addingNew: 1
            });

            try {
                let res = await fetch(UserStore.url + '/mgnew', {
                    method: 'post',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        attr: {
                            IstBlankoMG: true
                        }
                    })
                });
                let result = await res.json();

                if (result.success && result.data.errorMessage === null) {

                    //Mitgliedsnummer im Blanko Mode bekommen
                    let res = await fetch(UserStore.url + '/mgblanko', {
                        method: 'post',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            attr: {
                                Mitgliedsnummer: result.data.mitgliedsnummer
                            }
                        })
                    });
                    let resultBlanko = await res.json();

                    this.setState({
                        addingNew: 2,
                        addedNewNr: resultBlanko.data.mitgliedsnummer
                    });
                } else {
                    toast.error("Anlegen der neuen Blanko-Mitgliedsnummer ist fehlgeschlagen (" + result.data.errorMessage + "). Versuchen Sie es später noch einmal oder kontaktieren Sie den Support!", {
                        autoClose: 10000
                    });
                }

            } catch (e) {
                console.log("Error in create blanko-MG: " + e);
            }
        }

        this.loadListe();
        this.loadGridSettings();
    }

    async loadListe(onlyActive = true) {

        let endpoint = "";
        switch (this.props.mode) {
            case "neu":
                endpoint = "neumitglieder";
                break;
            case "blanko":
                endpoint = "mitgliederblanko"; //@todo hier Muss noch die neue Funktion dann rein der API (noch nicht vorhanden)
                break;
            default:
                endpoint = "mitglieder";
        }

        this.setState({
            onlyActive: onlyActive,
            mitglieder: [],
            loading: true,
            updateTitle: (endpoint === "mitglieder"),
        })

        try {

            let res = await fetch(UserStore.url + '/' + endpoint, {
                method: 'post',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            });

            let result = await res.json();

            //Check counts manually
            let mtglNew = result.data.mitglieder.length;
            let mtglBonus = 0;
            if (endpoint === "neumitglieder") {
                mtglNew = result.data.anzahlNeumitglieder;
                mtglBonus = result.data.anzahlNeumitgliederBonus;
                /**
                for(let i=0;i<result.data.mitglieder;i++) {
                    if( result.data.mitglieder[i].istBonusMG ) {
                        mtglBonus++;
                    }
                }*/
            }
            if (result && result.success) {
                this.setState({
                    mitglieder: result.data.mitglieder,
                    loading: false,
                    mtglNew: mtglNew,
                    mtglBonus: mtglBonus,
                });
            }

            if (endpoint === "mitglieder" && this.state.numShow !== -1) {
                document.title = 'Mitglieder (' + this.state.numShow + ') | ' + UserStore.title;
            }


        } catch (e) {
            console.log("Error in loading Mitgliederliste: " + e);
        }
    }

    getAddingNew() {
        switch (this.state.addingNew) {
            case 1:
                return (
                    <div>
                        <h3>Blanko-Mitglied erstellen</h3>
                        <div className="alert alert-warning" role="alert">Neues Mitglied wird gerade erstellt... Einen Moment bitte...</div>
                    </div>
                )
            case 2:
                return (
                    <div>
                        <h3>Blanko-Mitglied erstellt</h3>
                        <div className="alert alert-success" role="alert">
                            Neues Blanko-Mitglied erstellt: Neue Nummer: <a href={`/mitglied/${this.state.addedNewNr}`}>{this.state.addedNewNr}</a><br />
                            <small>Klicken Sie auf die neue Nummer, um weitere Aktionen mit diesem Blanko-Mitglied zu starten!</small>
                        </div>
                    </div>
                )
            default:

        }
    }

    getHeader(withAdd: boolean, withInfo: boolean) {
        if (this.props.mode === 'neu') {
            return (
                <div>
                    <h3>Neue Mitglieder</h3>
                    <div className="alh_subheader">
                        Sehen Sie hier Ihre aktuellen Neu-Mitglieder.
                        <br />
                        Anzahl Neumitglieder gesamt: <span className="alh_bold">{this.state.mtglNew}</span><br />
                        Anzahl Neumitglieder gem. Bonus: <span className="alh_bold">{this.state.mtglBonus}</span>
                    </div>
                </div>
            )
        } else
            if (this.props.mode === 'blanko') {
                return (
                    <div>
                        <h3 className={(!withAdd) ? "alh_pageheader_topspace" : "alh_pageheader"}>Blanko Mitglieder <a href="/mitgliedBlankoNew"><FontAwesomeIcon icon={faPlus} title="Neues Blankoelement hinzufügen" className={(withAdd) ? "faButton" : "d-none"} /></a></h3>
                        {withInfo &&
                            <div className="alh_subheader">Sehen Sie hier alle
                                Blankomitglieder, welche Sie bereits angelegt haben. Über das blaue +
                                können Sie weitere Blankomitglieder erstellen und anschließend die Beitrittserklärung mit der
                                vergebenen Mitgliedsnummer drucken.
                            </div>
                        }
                    </div>
                )
            } else {
                return (
                    <div>
                        <h3>Meine Mitglieder</h3>
                        <div className="alh_subheader">Sehen Sie hier alle Ihre Mitglieder. Verwenden Sie die "Suche" oder die "Sortierung", um schneller das gesuchte Mitglied zu finden.<br />
                            Mitglieder, welche mit einem roten Hintergrund versehen sind, haben gekündigt, sind aber noch bis zum 31.12. aktiv.<br />
                            Alle gekündigten Mitglieder können Sie einblenden, wenn Sie rechts neben der Suche bei “Nur Aktive” auf “Alle” umstellen. Bei den durchgestrichenen Mitgliedern ist die Mitgliedschaft bereits beendet.</div>
                    </div>
                )
            }
    }

    changeSearch(val: string) {
        this.setState({
            search: val,
        })
    }

    getMainTel(phone: string) {
        if (phone && phone.indexOf("|") > 0) {
            return (phone.split("|")[0]).trim();
        } else {
            return phone;
        }
    }

    onlyActive(val: boolean) {
        this.loadListe(val);
    }

    sortClick(spalte: string) {
        let newSort_mode = this.state.sort_mode;
        let newSort = this.state.sort;

        if (spalte === this.state.sort) {
            switch (this.state.sort_mode) {
                case 'asc':
                    newSort_mode = 'desc';
                    break;
                default:
                    newSort_mode = 'asc';
                    break;
            }
        } else {
            newSort = spalte;
        }

        this.setState({
            sort: newSort,
            sort_mode: newSort_mode,
        })
    }


    async printBE(mGNr: string) {

        await MitgliedService.mitgliedPrintFile(mGNr, "rptMGBeitrittserklaerung", "D", "", mGNr + "_Blanko_BE.pdf")

        return true;
    }

    numberFormat(number: number) {
        return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(number);
    }

    saveGridSettings() {
        const state = this.gridApiRef.current?.exportState();

        if (!state)
            return;

        const json = JSON.stringify(state, null, 2);
        localStorage.setItem(this.gridSettingsStorageKey, json);
        toast.success("Tabelleneinstellungen erfolgreich gespeichert!", {
            autoClose: 5000
        });
    }

    loadGridSettings() {
        const json = localStorage.getItem(this.gridSettingsStorageKey);

        if (!json)
            return;

        try {
            const state = JSON.parse(json);
            this.gridApiRef.current?.restoreState(state);
        } catch (e) {
            console.error("Fehler beim Laden der MUI DataGrid Settings:", e);
        }
    }
    

    getGridColumns(): GridColDef[] {
        if (this.gridColumns !== null && this.gridColumnsMode === this.props.mode) {
            return this.gridColumns;
        }

        const commonColumns: GridColDef[] = [
            {
                field: 'mgNr',
                headerName: 'Nr.',
                width: 110,
                renderCell: (params: GridRenderCellParams) => (
                    <a href={`/mitglied/${params.row.mgNr}`}>
                        {params.row.mgNr}
                    </a>
                ),
            },
            {
                field: 'name',
                headerName: 'Name',
                flex: 1,
                minWidth: 150,
            },
        ];

        let columns: GridColDef[];

        if (this.props.mode === 'blanko') {
            columns = [
                ...commonColumns,
                {
                    field: 'actions',
                    headerName: '',
                    width: 80,
                    sortable: false,
                    filterable: false,
                    disableColumnMenu: true,
                    renderCell: (params: GridRenderCellParams) => (
                        <FontAwesomeIcon
                            onClick={() => this.printBE(params.row.mgNr ?? '')}
                            icon={faPrint}
                            title="BE drucken"
                            className="faButton"
                        />
                    ),
                },
            ];
        } else if (this.props.mode === 'neu') {
            columns = [
                ...commonColumns,
                {
                    field: 'beitritt',
                    headerName: 'Beitritt',
                    width: 130,
                    valueFormatter: (value) =>
                        value ? moment(value).format('DD.MM.YYYY') : '',
                },
                {
                    field: 'beitrag',
                    headerName: 'Beitrag',
                    width: 130,
                    type: 'number',
                    align: 'right',
                    valueFormatter: (value) =>
                        value !== null && value !== undefined
                            ? this.numberFormat(Number(value))
                            : '',
                },
                {
                    field: 'be',
                    headerName: 'BE',
                    width: 100,
                },
                {
                    field: 'info',
                    headerName: 'Info',
                    flex: 1,
                    minWidth: 150,
                },
                {
                    field: 'istBonusMG',
                    headerName: 'Bonus',
                    width: 100,
                    type: 'boolean',
                    align: 'right',
                },
                {
                    field: 'actions',
                    headerName: '',
                    width: 80,
                    sortable: false,
                    filterable: false,
                    disableColumnMenu: true,
                    renderCell: (params: GridRenderCellParams) => (
                        <a href={`/mitglied/${params.row.mgNr}`}>
                            <FontAwesomeIcon
                                icon={faEdit}
                                title="Bearbeiten"
                                className="faButton faButtonSpaceright"
                            />
                        </a>
                    ),
                },
            ];
        } else {
            columns = [
                ...commonColumns,
                {
                    field: 'namePartner',
                    headerName: 'Partner',
                    flex: 1,
                    minWidth: 150,
                },
                {
                    field: 'plzOrt',
                    headerName: 'Ort',
                    width: 180,
                },
                {
                    field: 'telefon',
                    headerName: 'Telefon',
                    width: 150,
                    align: 'right',
                    valueGetter: (value) => this.getMainTel(value ?? ''),
                },
                {
                    field: 'eMail',
                    headerName: 'E-Mail / E-Mail Einwilligung',
                    flex: 1,
                    minWidth: 250,
                    renderCell: (params: GridRenderCellParams) => {
                        if (!params.row.eMail) {
                            return null;
                        }

                        return (
                            <a
                                href={
                                    "mailto:" +
                                    params.row.eMail +
                                    "?subject=" +
                                    params.row.mgNr +
                                    " " +
                                    (params.row.name?.replace(",", "") ?? "")
                                }
                            >
                                {params.row.eMail + " | " + (params.row.eMailEinwilligung ? "Ja" : "Nein")}
                            </a>
                        );
                    },
                },
                {
                    field: 'postbox',
                    headerName: 'Postbox',
                    width: 150,
                    align: 'right',
                    renderCell: (params: GridRenderCellParams) => (
                        params.row.postbox ? (
                            <a
                                href="https://www.alh-postbox.de/"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Ja
                            </a>
                        ) : "Nein"
                    ),
                },
                {
                    field: 'kuendWirksamDatum',
                    headerName: 'Kündigung',
                    width: 150,
                    align: 'right',
                    valueFormatter: (value) =>
                        value ? moment(value).format('DD.MM.YYYY') : '',
                },
                ...(window.innerWidth < 768 ? [{
                    field: 'actions',
                    headerName: 'Kontakt',
                    width: 80,
                    sortable: false,
                    filterable: false,
                    disableColumnMenu: true,
                    renderCell: (params: GridRenderCellParams) => (
                        <a
                            href={`tel:${this.getMainTel(params.row.telefon ?? '')}`}
                            className="alh_noprint"
                        >
                            <FontAwesomeIcon
                                icon={faPhone}
                                title="Anrufen"
                                className="alh_noprint faButton faButtonSpaceright"
                            />
                        </a>
                    ),
                } as GridColDef] : []),
            ];
        }

        this.gridColumns = columns;
        this.gridColumnsMode = this.props.mode;

        return columns;
    }

    render() {
        const { withAdd = true, withInfo = true } = this.props;
        let currentList = this.state.mitglieder;
        if (this.state.onlyActive) {
            currentList = currentList.filter((mitglied) =>
                mitglied.status === 0 ||
                mitglied.status === 1
            );
        }
        if (this.state.search !== "") {
            const search = this.state.search.toLowerCase();
            currentList = currentList.filter((mitglied) =>
                mitglied.name?.toLowerCase().includes(search) ||
                mitglied.namePartner?.toLowerCase().includes(search) ||
                mitglied.mgNr?.toLowerCase().includes(search) ||
                mitglied.telefon?.toLowerCase().includes(search) ||
                mitglied.plzOrt?.toLowerCase().includes(search)
            );
        }

        if (this.state.updateTitle) {
            document.title = 'Mitglieder (' + currentList.length + ') | ' + UserStore.title;
        }
        const rows = currentList.map((mitglied) => ({
            ...mitglied,
            id: mitglied.mgNr,
        }));

        const columns = this.getGridColumns();

        const initialSortModel = [
            {
                field: this.state.sort,
                sort: this.state.sort_mode as 'asc' | 'desc',
            },
        ];

        return (
            <div>
                {this.getAddingNew()}

                {this.getHeader(withAdd, withInfo)}

                {(this.props.mode !== 'blanko' && this.props.mode !== 'neu') &&
                    <TableOperatorOptions
                        name="Mitgliederliste"
                        placeholder="Suche nach Name, Nummer, Ort oder Telefon..."
                        onChange={(val) => this.changeSearch(val)}
                        value={this.state.search}
                        onlyActive={(val) => this.onlyActive(val)}
                        print={true}
                        onSave={() => this.saveGridSettings()}
                        onReset={() => {
                            localStorage.removeItem(this.gridSettingsStorageKey);

                            const api = this.gridApiRef.current;
                            columns.forEach((column, index) => {
                                api.setColumnIndex(column.field, index);
                                api.setColumnWidth(column.field, column.width ?? 100);
                                api.setColumnVisibility(column.field, true);
                            });
                        }}
                    />
                }

                <div className="alhWideGrid" style={{ marginTop: '10px' }}>
                    <DataGridPro
                        apiRef={this.gridApiRef}
                        localeText={deDE.components.MuiDataGrid.defaultProps.localeText}
                        rows={rows}
                        columns={columns}
                        rowHeight={32}
                        columnHeaderHeight={36}
                        loading={this.state.loading}
                        initialState={{
                            sorting: {
                                sortModel: initialSortModel,
                            },
                            pagination: {
                                paginationModel: {
                                    pageSize: 25,
                                    page: 0,
                                },
                            },
                        }}
                        pageSizeOptions={[10, 25, 50, 100]}
                        disableRowSelectionOnClick
                        getRowClassName={(params) => {

                            if (params.row.status === 2) {
                                return "deleted";
                            }
                            if (params.row.status === 1) {
                                return "warning";
                            }

                            return params.indexRelativeToCurrentPage % 2 === 0
                                ? "odd-row"
                                : "even-row";

                            return "";
                        }}
                    />
                </div>

                {currentList && currentList.length === 0 && !this.state.loading &&
                    <div className="info">Keine Einträge vorhanden!</div>
                }

                {this.state.loading &&
                    <div className="alhLoadingRel">
                        <WaveTopBottomLoading color="#ffc800" />
                    </div>}

            </div>
        );
    }
}

export default withRouter(Mitgliederliste);
